import styled from "styled-components";

export const WrapInput = styled.div`
  box-sizing: border-box;
  label {
    font-size: 0.28rem;
    letter-spacing: 0.03rem;
  }
  input {
    box-sizing: border-box;
    height: 0.7rem;
    padding: 0 16px;
    border: 1px solid #8c8c8c;
    background: #fff;
  }
  @media (max-width: 575px) {
    .ant-form-item .ant-form-item-label {
      padding: 0;
      line-height: 1.5715;
      white-space: initial;
      text-align: left;
    }
  }
  .ant-form-item {
    margin-bottom: 10px !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 2px;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  textarea {
    border: 1px solid #8c8c8c;
    height: 2.7rem !important;
  }
`;
